/** Kept separate from `actions.ts` so `reducer.ts` does not import the store-bound module (circular dependency). */
export enum CLOUD_ACCOUNT_ACTIONS {
  SET_ACCOUNTS = 'SET_ACCOUNTS',
  SET_SEGMENT_AND_GREEN_FIELD = 'SET_SEGMENT_AND_GREEN_FIELD',
  UPDATE_SEGMENT_AND_GREEN_FIELD = 'UPDATE_SEGMENT_AND_GREEN_FIELD',
}
